import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { AuthService } from "@services/auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class DallEGuard  {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasDallERole().pipe(map((hasRole) => {
      if (hasRole){
        return true;
      }else{
        return this.router.createUrlTree(['/error']);
      }
    }));
  }

  hasDallERole() : Observable<boolean>{
    return this.authService.userData$.pipe( map((userData) => {
        let roles = userData.roles;
        return roles != undefined && roles.includes('geneai_dall_e');
      })
    )
  }

}
